import Link from "next/link";
import { BrandLogo } from "@/components/brand-logo";
import { site } from "@/lib/data";

export function BrandLockup({
  logoClassName,
  priority = false,
  copyClassName = "flex min-w-0 flex-col justify-center leading-tight",
  inverted = false,
}: {
  logoClassName: string;
  priority?: boolean;
  copyClassName?: string;
  inverted?: boolean;
}) {
  return (
    <Link
      href="/"
      className="inline-flex min-h-12 min-w-0 max-w-full items-center gap-2.5 sm:gap-4"
      aria-label={site.name}
    >
      {inverted ? (
        <span className="inline-flex shrink-0 items-center justify-center rounded-xl bg-white p-1.5 shadow-sm">
          <BrandLogo className={logoClassName} priority={priority} />
        </span>
      ) : (
        <BrandLogo
          className={`shrink-0 ${logoClassName}`}
          priority={priority}
        />
      )}
      <span className={copyClassName}>
        <span
          className={`font-heading text-sm font-bold tracking-[0.08em] sm:text-lg sm:tracking-[0.1em] ${
            inverted ? "text-white" : "text-ink"
          }`}
        >
          {site.name.toUpperCase()}
        </span>
        <span className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-red sm:text-xs sm:tracking-[0.14em]">
          {site.tagline}
        </span>
      </span>
    </Link>
  );
}
